import { t } from '@lingui/core/macro';
import { DateRangeFilter } from './DateFilter';
export const createdAtFilterLabel = () => t({
    message: 'Created at',
    comment: 'Insights: Created at date filter',
});
export function CreatedAtFilter() {
    return <DateRangeFilter name="createdAt" label={createdAtFilterLabel()}/>;
}
